// src/components/ui/input.jsx
import React from 'react'

export function Input({ className = '', ...props }) {
  return (
    <input
      className={`w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-900 placeholder-zinc-400 focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-400/30 dark:border-white/[0.08] dark:bg-white/[0.04] dark:text-zinc-100 dark:placeholder-zinc-500 ${className}`}
      {...props}
    />
  )
}
